const flyoutClass = () => {
  var submenus = document.getElementsByClassName("sub-menu");
  for (let index = 0; index < submenus.length; index++) {
    const submenu = submenus[index];
    if (submenu.children.length > 5) {
      submenu.classList.add("flyout");
      submenu.parentNode.classList.add("flyout-parent");
      const bar = document.createElement("div");
      bar.classList.add("flyout-bar");
      submenu.parentNode.insertBefore(bar, submenu);
      bar.appendChild(submenu);
    }
  }
};

export { flyoutClass };
